import './index.scss';
import React, { PropTypes } from 'react';
import _ from 'underscore';
import { isUndefinedNullOrEmpty } from '../../../js/utils';
import SelectWithLoading from '../SelectWithLoading';
import { itemsPropTypes } from '../commonPropTypes';

const SelectWithAddEditControl = React.createClass({
    propTypes: {
        items: itemsPropTypes,
        isLoading: PropTypes.bool,
        value: PropTypes.string.isRequired,
        onChange: PropTypes.func.isRequired,
        setupNewLabel: PropTypes.string.isRequired,
        disabled: PropTypes.bool,
        autoFocus: PropTypes.bool,
        onAddClick: PropTypes.func,
        onEditClick: PropTypes.func,
    },
    onServerEditRequested: function(e) {
        e.preventDefault();
        const { onEditClick } = this.props;
        if(onEditClick) { onEditClick(); }
    },
    onServerAddRequested: function(e) {
        e.preventDefault();
        const { onAddClick } = this.props;
        if(onAddClick) { onAddClick(); }
    },
    render: function () {
        const { items, value, disabled, autoFocus, onChange, onEditClick, onAddClick, isLoading, setupNewLabel } = this.props;
        const hasEdit = _.isFunction(onEditClick);
        const hasAdd = _.isFunction(onAddClick);
        const isEditable = !isUndefinedNullOrEmpty(value);

        return (
            <div>
                <div className="pure-g">
                    <div className="pure-u-16-24">
                        <SelectWithLoading items={items} value={value} disabled={disabled} autoFocus={autoFocus} isLoading={isLoading} onChange={onChange} />
                    </div>

                    <div className="pure-u-1-24"></div>

                    {(!disabled && !isLoading) &&
                        <div className="pure-u-7-24 connection-controls-holder">
                            {(isEditable && hasEdit) && <span>
                                <a onClick={this.onServerEditRequested} href="#">Edit</a><span> | </span>
                            </span>}

                            {hasAdd && <span>
                                <a className="button--flat" onClick={this.onServerAddRequested} href="#">{setupNewLabel}</a>
                            </span>}
                        </div>
                    }
                </div>
            </div>
        );
    }
});

export default SelectWithAddEditControl;



// WEBPACK FOOTER //
// ./src/components/common/SelectWithAddEditControl/index.jsx